import { render, staticRenderFns } from "./FileImport.vue?vue&type=template&id=94104cd2&"
import script from "./FileImport.vue?vue&type=script&lang=js&"
export * from "./FileImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports